"use client";

import { useWalleyCheckoutForm } from "./Walley.hooks";
import WalleyCustomerPicker from "./WalleyCustomerPicker";
import WalleyErrorMessage from "./WalleyErrorMessage";
import WalleyLoadingSkeleton from "./WalleyLoadingSkeleton";
import WalleyWidget from "./WalleyWidget";

export default function Walley() {
  const { data, isPending, isError, error } = useWalleyCheckoutForm();

  if (isPending) {
    return <WalleyLoadingSkeleton />;
  }

  if (isError) {
    if (error?.message) {
      return <WalleyErrorMessage message={error?.message} />;
    }
    return <WalleyErrorMessage message="An unknown error occured" />;
  }

  return (
    <>
      <WalleyCustomerPicker />
      {data?.formHtml && <WalleyWidget snippet={data.formHtml} />}
    </>
  );
}
